<template>
    <div>
        <div class="orderviewboxs">
            <div class="orderviewbox">
                <div class="title">
                    订单信息
                </div>
                <div class="all">
                    <!-- <div class="title">报名赛事</div> -->
                    <div class="body" style="color:#FAAE3A;display:inline-block;font-size: 32rpx;text-align: center;font-weight: bold;margin-bottom: 20rpx;" @click="bindClick">{{registermatchinfo.title}}</div>
                </div>
                <div class="all">
                    <div class="title">报名组别</div>
                    <div class="body">{{orderInfo.typename}}</div>
                </div>
                <div class="all">
                    <div class="title">报名费用</div>
                    <div class="body">{{orderInfo.fees*1==0?"免费":"¥"+orderInfo.fees}}</div>
                </div>
                <div class="all">
                    <div class="title">订单编号</div>
                    <div class="body">{{orderInfo.order_no}}</div>
                </div>
                <div class="all">
                    <div class="title">订单状态</div>
                    <div :class="[formtite(orderInfo.state,orderInfo.ischeck).class,'body']">{{formtite(orderInfo.state,orderInfo.ischeck).text}}</div>
                </div>
            </div>
            <div class="form" v-for="items in memberAttrsValue" :key="items.id">
                <div class="content" v-for="item in items.attrs" :key="item.id">
                    <div class="title">{{item.show_name}}</div>
                    <div class="body">{{item.value}}</div>
                </div>     
            </div>
        </div>
        <div class="footer apppadding button" v-if="orderInfo.ischeck==1 &&  orderInfo.state!=1 && orderInfo.state!=3 &&  sys_time < registermatchinfo.end_time">
            <div class="vbtn">
                <Button type="warning" @click="signUp" size="large" :disabled="paydisabled" round>支付</Button>
            </div>         
        </div>
    </div>
</template>

<script>
  import './orderview.less'
  import {Button} from 'vant';
  import { orderdetail, prememberlist} from '@/libs/api'
  import {setStorage, getStorage} from '@/libs/utils'

  export default {
    name: 'userlist',
    components: {
        Button
    },
    data() {
        return {
            orderInfo: {},
            memberAttrsValue: [],
            registermatchinfo:{},
            postparams: {},
            paydisabled:false,
            sys_time: ''
        }
    },
    methods:{
        formtite(state,ischeck){
            if(ischeck==1){
                switch(state*1){
                    case 1:
                        return {'text':'报名成功','class':'success'};
                    case 2:
                        return {'text':'待支付','class':''};
                    case 3:
                        return {'text':'已退款','class':''};
                    case 101:
                        return {'text':'订单超时','class':''};
                }
            }else{
                return {'text':'待审核','class':'checkining'};
            }
        },
        signUp(){
            this.paydisabled = true
            var params  =   this.postparams;
            params.paytype = 2;
            params.paymethod = 1;
            params.returnurl = 'wap';
            var url = window.location.href
            params.payurl = url
            this.$router.replace({name:"mppay",params:params});
        },
        orderlist(){
            orderdetail(this.postparams).then((res)=>{
                if(res.status==200){
                    this.registermatchinfo = res.data.matchinfo
                    this.orderInfo = res.data.order
                    this.sys_time = res.sys_time
                }else{
                    this.registermatchinfo = {}
                    this.orderInfo = {}
                }
            })
        },
        memberlist(){
            prememberlist(this.postparams).then((res)=>{
                if (res.status == 200) {
                    this.memberAttrsValue = res.data.list
                } else {
                    this.memberAttrsValue = []
                }
            })
        },
        bindClick(){
            this.$router.push({name:'mdetail',params:{matchid:this.postparams.matchid}})
            // this.$router.push({name:'mdetail',params:{matchid:e}})
            // 
        }
    },
    mounted() {
        this.$nextTick(() => {
            let userinfo = getStorage('userInfo')
            this.postparams = this.$route.params
            this.postparams.urid = userinfo.urid
            this.postparams.token = userinfo.token
            this.orderlist()
            this.memberlist()
        })
    }

  }
</script>